import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MobileScreenRouteGuard  {
  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    console.log("Mobile Route Guard --> ", state.url);
    const screenSize = window.innerWidth;
    if (screenSize > 768) {
      console.log("Navigating to /d");
      return this.router.parseUrl(`/d`);
    }
    return true;
  }
}
